<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15fw1Jp/tc-custom/9781938120480.jpg?1701060966938" alt="This image is the cover for the book Era, 1947–1957"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Era, 1947–1957
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The author of <i>The Boys of Summer </i>explores the golden age of baseball, an unforgettable time when the game thrived as America’s unrivaled national sport.</b><br/><br/><i>The Era</i> begins in 1947, with Jackie Robinson changing major league baseball forever by taking the field for the Dodgers. Dazzling, momentous events characterize the decade that followed—Robinson’s amazing accomplishments; the explosion on the national scene of such soon-to-be legends as Mickey Mantle, Willie Mays, Bobby Thomson, Duke Snider, and Yogi Berra; Casey Stengel’s crafty managing; the emergence of televised games; and the stunning success of the Yankees as they play in nine out of eleven World Series. <i>The Era</i> concludes with the relocation of the Dodgers from Brooklyn to Los Angeles, a move that shook the sport to its very roots.<br/><br/><b>“Kahn knows where the bodies are buried and allows his audience a joyous read as he digs them up.”—<i>Publishers Weekly</i><br/><br/> “[Kahn] engagingly captures the flavor of the times by bringing to the fore the defining traits and relationships that added human dimension to the sport.”—<i>Library Journal</i></b><br/><br/><b>“Kahn weaves such personal information into his rich descriptions of thrilling regular-season, playoff and World Series games. And in doing so he endows the players, managers and owners with more dynamic dimensions than any baseball writer of his generation. The men in <i>The Era</i> are ballplayers, not deities; and it takes the unerring strength of a straight shooter like Kahn to remind nostalgic baseball fans of that simple fact.”—<i>Chicago Tribune</i></b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Roger Kahn
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Please add a publisher
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4e991909